import { graphql } from 'react-relay';

export const requestSimpleAuthToken = graphql`
  mutation simpleAuthRequestTokenMutation($name: String!, $phone: String!, $birthday: String!, $certType: CertType!) {
    hometaxSimpleAuth(name: $name, phone: $phone, birthday: $birthday, certType: $certType) {
      result
      reqTxId
      token
      cxId
      errors {
        code
        message
      }
    }
  }
`;

export const requestSimpleAuthConfirmToken = graphql`
  mutation simpleAuthConfirmRequestTokenMutation(
    $name: String!
    $phone: String!
    $birthday: String!
    $certType: CertType!
    $reqTxId: String!
    $token: String!
    $cxId: String!
  ) {
    hometaxSimpleAuthConfirm(name: $name, phone: $phone, birthday: $birthday, certType: $certType, reqTxId: $reqTxId, token: $token, cxId: $cxId) {
      result
      token
      errors {
        code
        message
      }
    }
  }
`;

export const requestRefundTokenForLookup = graphql`
  mutation simpleAuthRequestRefundTokenForLookupMutation($corpType: CorpTypeEnum!, $loginType: LoginType!, $token: String!, $tin: String) {
    requestRefundTokenMutation: checkHometaxAccount(corpType: $corpType, loginType: $loginType, simpleAuth: { token: $token }, tin: $tin) {
      result
      errors {
        code
        message
      }
      refundToken
      email
      lastLoginType
    }
  }
`;

export const requestRefundToken = graphql`
  mutation simpleAuthRequestRefundTokenMutation($corpType: CorpTypeEnum!, $loginType: LoginType!, $token: String!) {
    requestRefundTokenMutation: hometaxLogin(corpType: $corpType, loginType: $loginType, simpleAuth: { token: $token }) {
      result
      errors {
        code
        message
      }
      refundToken
    }
  }
`;
